import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { iFMessage, FMessage } from '../../../../hoc/IntlComponents';
import { Table } from 'reactstrap';
import Card from '../../../../components/Card/Card';
import chartBaseConfig from '../../../../components/Offer/TargetAudience/chartBaseConfig';

const { title, chart, series, ...rest } = chartBaseConfig;

const sorting = ['geo', 'demography', 'sources'];

class OfferTargetAudience extends Component {
  getChartConfig = ({ h, config }) => {
    const { intl } = this.props;
    return {
      chart: {
        ...chart,
        height: h,
      },
      title: {
        ...title,
        text: iFMessage({ intl, id: `offer.target-audience.chart.title.${config.settings.title}` }),
      },
      series: [
        {
          ...series,
          data: config.data,
        },
      ],
      ...rest,
    };
  };

  renderAudienceStats4 = ({ audience }) => {
    const charts = [];

    let titles = Object.keys(audience).filter(title => this.props.type === 'demography' ? title === 'demography' : title !== 'demography') 

    return titles.map(title => (
      <React.Fragment key={title}>
        <thead>
          <tr>
            <td className="font-weight-bold pb-1">
              <FMessage id={`offer.target-audience.table.title.${title}`} />
            </td>
          </tr>
        </thead>
        <tbody>
          {Object.keys(audience[title]).map(key => (
            <tr>
              <td className="py-2">{key}</td>
              <td className="py-2 text-right">{audience[title][key] + '%'}</td>
            </tr>
          ))}
        </tbody>
      </React.Fragment>
    ));
  };
  sortStats = stats => stats.sort((a, b) => sorting.indexOf(a) - sorting.indexOf(b));

  render() {
    const {type} = this.props;
    const audience = JSON.parse(this.props.audience);
    const audienceStats = this.sortStats(Object.keys(audience));

    if (!audienceStats || !audienceStats.length) {
      return null;
    }

    return (
      <Card collapsing className="offer-target-audience">
        <Card.Header>
          <FMessage id={ type === 'demography' ? "offer.target-audience.title.theme_4" : "offer.target-audience.title.sources.theme_4"} />
        </Card.Header>
        <Card.Body className="target-audience-chart-wrapper no-padding">
          <Table responsive>{this.renderAudienceStats4({ audience })}</Table>
        </Card.Body>
      </Card>
    );
  }
}

export default injectIntl(OfferTargetAudience);
